import { FC } from 'react';
import { useParams } from 'react-router-dom';
import { useQueryClient } from "react-query";
import { useGetOption } from '../../../services/option/option.service';
import { useFetchErrorToast } from '../../../utils/useFetchErrorToasts/useFetchErrorToast';
import useNavigateWithToast from '../../../utils/useNavigateWithToast/useNavigateWithToast';
import Header from "../../Bases/Header";
import Loading from "../../../components/Loading/Loading";
import EditOptionForm from "./EditOptionForm";

const EditOption: FC = () => {
  const navigateWithToast = useNavigateWithToast();
  const queryClient = useQueryClient();
  const {
    classId: classIdParam,
    optionId: optionIdParam
  } = useParams<{ classId: string, optionId: string }>();
  const classId = +(classIdParam ?? '-1');
  const optionId = +(optionIdParam ?? '-1');

  const {
    data: getOptionResponse,
    isError: getOptionIsError,
    error: getOptionError
  } = useGetOption({ classId, optionId });
  const option = getOptionResponse?.data;

  useFetchErrorToast([
    {
      label: "Error fetching option data",
      id: 'optionDataFetchError',
      isError: getOptionIsError,
      error: getOptionError
    }
  ]);

  const navigateToTableWithSuccessToast = () => {
    queryClient.invalidateQueries(['getOption', classId, optionId]);
    navigateWithToast(
        '/tables/options',
        {
          label: 'Option has been updated successfully',
          id: 'optionUpdateSuccess'
        }
    );
  };

  return (
      <>
        <Header
            breadcrumb={{ label: "Back to Option Table", to: '/tables/options' }}
            title={`View Option ${option?.optionNo ?? ''} - ${option?.longDescription ?? ''}`}
        />
        {!!option
            ? <EditOptionForm
                option={option}
                onSuccess={navigateToTableWithSuccessToast}
            />
            : <Loading size={12}/>
        }
      </>
  );
};

export default EditOption;